import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import {
  HOME_SCREEN_INSTALL_VERSION_KEY,
  HOME_SCREEN_START_PARAM,
} from '@app/features/home-screen-icon/domain/properties/home-screen-icon.props';
import { StorageService } from '@app/services/storage/storage';

/** Runs before the initial navigation, while the launch URL still carries the manifest's `hs` marker. */
export function homeScreenInstallInitializer(): void {
  const browserWindow = inject(DOCUMENT).defaultView;

  if (!isPlatformBrowser(inject(PLATFORM_ID)) || !browserWindow) {
    return;
  }

  const marker = new URLSearchParams(browserWindow.location.search).get(HOME_SCREEN_START_PARAM);

  if (marker !== null && marker !== '') {
    inject(StorageService).setLocalItem(HOME_SCREEN_INSTALL_VERSION_KEY, marker);
  }
}
